import "react-datepicker/dist/react-datepicker.css";

import * as React from "react";
import "./Spinner.scss";

export interface SpinnerProps {
    color?: "red" | "white" | "grey";
    type?: "page" | "basic";
    size?: number;
    isLoading: boolean;
}

export const Spinner = (props: SpinnerProps) => {
    const type = props.type === "page" ? "page-loading" : undefined;

    return (
        <>
            {props.isLoading && (
                <div className={type}>
                    <svg className={"loading-spinner " + props.color} width={props.size ? props.size : 40} viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg">
                        <g fill="currentColor" stroke="currentColor">
                            <path transform="translate(31.209 24.263)" d="m27.975 5.737c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4z" />
                            <path d="m49.325 6.3758c-2.1589-1.7217-5.3047-1.3672-7.0263 0.79168-1.7217 2.1589-1.3672 5.3047 0.79168 7.0263 2.1589 1.7217 5.3047 1.3672 7.0263-0.79168 1.7217-2.1589 1.3672-5.3047-0.79168-7.0263z" />
                            <path d="m23.457 0.31967c3.2299-0.73721 6.4459 1.2835 7.1831 4.5135 0.73721 3.2299-1.2835 6.4459-4.5135 7.1831-3.2299 0.73721-6.4459-1.2835-7.1831-4.5135-0.73721-3.2299 1.2835-6.4459 4.5135-7.1831z" />
                            <path d="m1.3122 17.334c-1.1979 2.4874-0.1525 5.4749 2.3349 6.6727 2.4874 1.1979 5.4749 0.1525 6.6727-2.3349 1.1979-2.4874 0.1525-5.4749-2.3349-6.6727-2.4874-1.1979-5.4749-0.1525-6.6727 2.3349z" />
                            <path d="m1.1137 41.796c-0.71872-1.4924-0.091498-3.2849 1.4009-4.0036 1.4924-0.71872 3.2849-0.0915 4.0036 1.4009 0.71872 1.4924 0.091498 3.2849-1.4009 4.0036-1.4924 0.71872-3.2849 0.0915-4.0036-1.4009z" />
                            <path d="m20.736 56.767c1.3458 0.30717 2.6858-0.53481 2.993-1.8806s-0.53481-2.6858-1.8806-2.993-2.6858 0.5348-2.993 1.8806c-0.30717 1.3458 0.5348 2.6858 1.8806 2.993z" />
                            <path d="m46.078 52.06c-1.2953 1.033-3.1828 0.82032-4.2158-0.47501s-0.82032-3.1828 0.47501-4.2158c1.2953-1.033 3.1828-0.82032 4.2158 0.47501s0.82032 3.1828-0.47501 4.2158z" />
                            <path
                                transform="matrix(.70711 .70711 .70711 -.70711 16.856 24.97)"
                                d="m27.975 5.737c0 2.2091-1.7909 4-4 4s-4-1.7909-4-4 1.7909-4 4-4 4 1.7909 4 4z"
                                display="none"
                            />
                        </g>
                    </svg>
                </div>
            )}
        </>
    );
};
